import { useEffect, useState } from "react";
import axios from "axios";
import { Reveal, Kicker } from "@/components/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";
import { API } from "@/constants/assets";

export function Blog() {
  const { t } = useLanguage();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios.get(`${API}/posts`).then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  if (posts.length === 0) return null;

  return (
    <section id="journal" data-testid="blog-section" className="relative py-28 md:py-40 bg-[#14120F]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal><Kicker>{t("blog_kicker")}</Kicker></Reveal>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <Reveal delay={0.1}>
            <h2 className="font-serif-d text-4xl md:text-6xl mt-6 text-[#F7F4EE]">{t("blog_title")}</h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="text-sm text-[#B8B0A2] max-w-xs md:text-right">{t("blog_sub")}</p>
          </Reveal>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {posts.slice(0, 3).map((p, i) => (
            <Reveal key={p.id} delay={i * 0.1}>
              <article data-testid={`blog-card-${i}`} className="group border hairline bg-[#0B0A08] hover:border-[rgba(212,175,55,0.5)] transition-colors duration-500">
                {p.image && (
                  <div className="img-frame aspect-[16/10]">
                    <img src={p.image} alt={p.title} className="w-full h-full object-cover" loading="lazy" />
                  </div>
                )}
                <div className="p-7">
                  <div className="flex items-center justify-between">
                    <span className="text-[10px] font-mono-d tracking-[0.25em] uppercase text-[#D4AF37]">{p.category}</span>
                    <span className="text-[10px] font-mono-d text-[#7A7367]">
                      {new Date(p.created_at).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" })}
                    </span>
                  </div>
                  <h3 className="font-serif-d text-xl md:text-2xl mt-4 text-[#F7F4EE] leading-snug">{p.title}</h3>
                  <p className="mt-3 text-sm text-[#B8B0A2] leading-relaxed">{p.excerpt}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
